
@if(form()){
<form [formGroup]="form()">
    <div class="grid grid-cols-1 gap-4 mb-4">

    @if(isInsert()){
    <spike-field-number label="Quantità" formControlName="quantity" errorMessage="Campo non valido" placeholder="quantity" class="mb-2"></spike-field-number>
    <spike-field-text-area label="Note" formControlName="description" errorMessage="Campo non valido" placeholder="description" class="mb-2"></spike-field-text-area>
    }
    @if(!isInsert()){
    <spike-field-select label="Fornitore" [initialValue]="organizationStore.getSupplier(supplierId)()" formControlName="supplierId" selectKey="supplierId" selectValue="shortDescription" listTitle="Seleziona fornitore" detailTitle="Dettaglio fornitore">
        <ng-template #list>
            <spike-organization-list #listRef 
                [modelApi]="supplierModelApi"
                [entityApi]="supplierApi"
                [etiquetteApi]="supplierEtiquetteApi"
                entityKey="supplierId">
            </spike-organization-list>
        </ng-template>
    </spike-field-select>
   
    <spike-field-date  icon ="pi pi-calendar" label="Data ordine" formControlName ="sendDate"></spike-field-date>
    @if(sendDate){<spike-field-date  icon ="pi pi-calendar" label="Data arrivo stimata" formControlName ="extimatedDeliveryDate"></spike-field-date>}
    @if(sendDate){<spike-field-date  icon ="pi pi-calendar" label="Data arrivo" formControlName ="deliveryDate"></spike-field-date>}
    }   
  

    </div>
    
</form>
}
